import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

const DatePicker = (props) => {
	const {value, onChange, closeOnSelect, timeFormat, dateFormat, clearable, readOnly, placeholder, ...rest} = props;

	const clearDatePicker = () => {
		onChange('');
	};

	return (
		<div className="date-picker">
			<Datetime
				value={value}
				onChange={onChange}
				closeOnSelect={closeOnSelect}
				timeFormat={timeFormat}
				dateFormat={dateFormat}
				inputProps={{readOnly, placeholder}}
				{...rest}
			/>
			{value && clearable && <button type="button" className="date-picker-clear" onClick={clearDatePicker}>×</button>}
		</div>
	);
};

DatePicker.defaultProps = {
	closeOnSelect: true,
	timeFormat: false,
	dateFormat: 'YYYY-MM-DD',
	clearable: true,
	readOnly: true
};

DatePicker.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	onChange: PropTypes.func.isRequired,
	closeOnSelect: PropTypes.bool,
	timeFormat: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	dateFormat: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	clearable: PropTypes.bool,
	readOnly: PropTypes.bool
};

export default DatePicker;
